import { render, staticRenderFns } from "./LegalLayout.vue?vue&type=template&id=4d9bfc3c"
import script from "./LegalLayout.vue?vue&type=script&lang=js"
export * from "./LegalLayout.vue?vue&type=script&lang=js"
import style0 from "./LegalLayout.vue?vue&type=style&index=0&id=4d9bfc3c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports